import React from 'react'
import styled from 'styled-components'
import Modal from '../modal'
import Button from '../button'
import LoadingButton from '../loading-button'
import useUpdateDocumentStatus from '../hooks/useUpdateDocumentStatus'
import { DocumentStatusOption } from '../constants'

const ButtonsContainerElement = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 2rem;
`

function ArchiveModal({ documentId, onClose }) {
  const { updateStatus, loading } = useUpdateDocumentStatus()

  const handleClose = () => !loading && onClose()

  const handleSubmit = () =>
    updateStatus({
      documentId,
      newStatus: DocumentStatusOption.move_to_archived,
    })

  return (
    <Modal
      title="Are you sure you want to archive the document?"
      onClose={handleClose}
    >
      <ButtonsContainerElement>
        <Button color="gray" variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          disabled={loading}
          isLoading={loading}
          onClick={handleSubmit}
          width="5rem"
        >
          Archive
        </LoadingButton>
      </ButtonsContainerElement>
    </Modal>
  )
}

export default ArchiveModal
